import {
    REQUEST_CUSTOMERS,
    RECEIVE_CUSTOMERS,
    UPDATE_CUSTOMERS,
    ERROR_CUSTOMERS
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import {reloadEnums, getEnums} from "../actions"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_CUSTOMERS
    };
}

export function receive(data) {
    return {
        type: RECEIVE_CUSTOMERS,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_CUSTOMERS,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_CUSTOMERS,
        id,
        payload: data,
        updateType
    }
}

export function getCustomers(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().customers, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'customers',
                params: prepareFilters(params, getState(), "customers")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getCustomer(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('customer'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'customers/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createCustomer(data, fromSelect = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'customers',
                data
            }).then(res => {
                if(fromSelect){
                    dispatch(getEnums('customers', {}, true));
                    dispatch(reloadEnums('customers'))
                    dispatch(reloadEnums('customersAndSuppliers'))
                    return res.data.data.id
                }else{
                    dispatch(receiveItem({}, 'message.item_created'))
                    dispatch(update(res.data.data, false, 'create'))
                    dispatch(reloadEnums('customers'))
                    dispatch(reloadEnums('customersAndSuppliers'))
                }
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateCustomer(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('customer'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'customers/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadEnums('customers'))
                dispatch(reloadEnums('customersAndSuppliers'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteCustomer(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'customers/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadEnums('customers'))
                dispatch(reloadEnums('customersAndSuppliers'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}